import styles from './Icons.module.css';
import { ReactComponent as Linkedin } from 'assets/social-links/linkedin.svg';

export const LinkedinIcon = () => (
    <div className={styles['icon']}>
        <Linkedin />
    </div>
);
